import { render, staticRenderFns } from "./arrow-down-left-and-arrow-up-right-to-center.svg?vue&type=template&id=2ae3fe3a&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports